const modifyProposedEventApprovedSpeakers = function (
  { commit },
  { id, field, value }
) {
  commit("MODIFY_EVENT_APPROVED_SPEAKERS", { id, field, value });
};

export default modifyProposedEventApprovedSpeakers;
